const refundPolicyES = {
	title: "Política de Reembolsos",
	lastUpdated: "Fecha de Vigencia",

	intro: {
		p1: `{{COMPANY_NAME}} (“nosotros”, “nuestro” o “nos”) proporciona una plataforma en línea que conecta a clientes con barberos, salones y otros proveedores de servicios. Esta Política de Reembolsos explica las circunstancias bajo las cuales pueden otorgarse reembolsos por tarifas pagadas a Sin Fila.`,
	},

	platformFees: {
		heading: "1. Tarifas de la Plataforma",
		p1: "Todos los pagos recaudados por Sin Fila corresponden al uso de la plataforma por parte de los negocios (tarifas de suscripción mensual u otras tarifas de la plataforma).",
		p2: "Sin Fila no procesa pagos entre clientes y proveedores de servicios, por lo que esta Política de Reembolsos no se aplica a los pagos de clientes por servicios reservados.",
	},

	eligibility: {
		heading: "2. Elegibilidad para Reembolso",
		list: [
			"Los reembolsos por tarifas de la plataforma solo se considerarán si el pago fue cobrado por error (cargo duplicado, monto incorrecto u otro error de facturación).",
			"Todas las demás solicitudes de reembolso se evaluarán caso por caso y su aprobación queda a la entera discreción de Sin Fila.",
		],
	},

	midMonth: {
		heading: "3. Cancelaciones a Medio Mes y Cambios de Personal",
		p1: "Si un negocio cancela su suscripción mensual, el acceso a los Servicios continuará hasta el final del período de facturación actual, y no se emitirán reembolsos por días no utilizados.",
		p2: "Excepción – Eliminación de Personal:",
		p3: "Si un barbero o negocio elimina a un miembro del personal a medio mes, la tarifa correspondiente a ese personal se prorrateará según los días restantes del período de facturación.",
		p4: "Los ajustes prorrateados se aplicarán automáticamente al siguiente ciclo de facturación o se reembolsarán a discreción de Sin Fila.",
	},

	process: {
		heading: "4. Proceso de Reembolso",
		p1: "Para solicitar un reembolso por un error de facturación, contacte a {{CONTACT_EMAIL}} dentro de los 30 días posteriores al pago original.",
		p2: "Incluya: nombre del negocio y correo electrónico de la cuenta, fecha y monto del pago, y motivo de la solicitud.",
		p3: "Los reembolsos aprobados se procesarán al método de pago original. Los tiempos de procesamiento pueden variar según bancos o proveedores de pago.",
	},

	nonRefundable: {
		heading: "5. Situaciones No Reembolsables",
		list: [
			"Tarifas por el uso de la plataforma ya proporcionado (acceso completo al mes), incluso si se cancela a medio mes, excepto ajustes prorrateados por eliminación de personal.",
			"Problemas técnicos con reservas causados por proveedores de servicios de terceros, conectividad a internet o errores del usuario.",
			"Interrupciones temporales o indisponibilidad de los Servicios, salvo en casos extraordinarios y a discreción exclusiva de Sin Fila.",
			"Pérdidas o daños reclamados por clientes o negocios como resultado del uso de la plataforma.",
		],
	},

	changes: {
		heading: "6. Cambios a la Política de Reembolsos",
		text: "Podemos actualizar esta Política de Reembolsos en cualquier momento. Las versiones actualizadas se publicarán en el sitio web y la aplicación. El uso continuado de los Servicios constituye aceptación de la Política actualizada.",
	},

	contact: {
		heading: "7. Contacto",
		text: "Para preguntas sobre esta Política de Reembolsos o para enviar una solicitud, escriba a {{CONTACT_EMAIL}}.",
	},
};

export default refundPolicyES;
